import { LoadableLazy } from '@confluence/loadable';

export const ManageWatcherDialogLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ManageWatcherDialog" */ './ManageWatcherDialog.js'
			)
		).ManageWatcherDialog,
});
